import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";
import { useSelector } from "react-redux";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { baseUrl } from "../../../../helper/urls";
import { Icon } from "@iconify/react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import moment from "moment-timezone";

const ScheduleBookings = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/bookings/getBookingUpComingCounselor`,
        { headers }
      );

      const data = response.data.data || [];

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        studentName: `${item.firstName || ""} ${item.lastName || ""}`.trim(),
        interestedIn: item.counselorinterestedIn || "",
      }));

      setBookings(processedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  function formatUtcTimeTo12Hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }

  function formatUtcTimeTo12HourAdd1hour(timeStr) {
    if (!timeStr) return "N/A";
    const d = new Date(timeStr);
    d.setUTCHours(d.getUTCHours() + 1); // Add 1 hour
    let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
  }
  const getTimeZoneAbbreviation = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment.tz(timeZone).format("z");
  };
  const timeZoneAbbreviation = getTimeZoneAbbreviation();
  const convertSlotsToStudentTimezone1 = (utcTime, type, duration = 60) => {
    if (!utcTime || !type) return "Invalid input";

    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startLocal = moment.utc(utcTime).tz(studentTimeZone);
    const tzAbbr = startLocal.format("z");
    console.log('clllllllll', studentTimeZone, tzAbbr)
    const endLocal = moment(startLocal).add(duration, "minutes");

    switch (type) {
      case "date":
        return startLocal.format("YYYY-MM-DD");
      case "start":
        return startLocal.format("hh:mm:ss A");
      case "end":
        return endLocal.format("hh:mm:ss A");
      default:
        return "Invalid type";
    }
  };
  const handleReschedule = (rowData) => {
    Swal.fire({
      html: `<h4 style="font-size:14px; margin-bottom: 10px; padding:20px;">Reschedule Booking</h4>
         <p>Please provide a reason for rescheduling:</p>`,
      input: "text",
      inputPlaceholder: "Enter reason here...",
      inputAttributes: {
        name: "reason",
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Reschedule",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      preConfirm: (reason) => {
        if (!reason) {
          Swal.showValidationMessage("Reason is required.");
        }
        return reason;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          slotId: rowData.slotId, // slot ID for the new time
          studentId: rowData.studentId, // student ID
          bookedId: rowData.id, // existing booking ID
          reason: result.value, // reason input from modal
        };

        axios
          .post(`${baseUrl}/api/reschedule/counselor/create`, payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // assumes token is stored in session
            },
          })
          .then((res) => {
            Swal.fire(
              "Rescheduled!",
              "The reschedule request has been sent to student.",
              "success"
            );
            fetchBookings(); // refresh the table/list if needed
          })
          .catch((error) => {
            console.error("Reschedule error:", error);
            const message =
              error.response?.data?.message ||
              error.message ||
              "Failed to reschedule.";
            Swal.fire("Error", message, "error");
          });
      }
    });
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("meet_link", {
      header: "Google Meet Link",
      Cell: ({ row }) => {
        const link = row.original?.meet_link;
        const rescheduleId = row.original?.rescheduleId;

        if (rescheduleId) return "-";
        if (!link) return "-";

        const copyToClipboard = () => {
          if (link) {
            navigator.clipboard.writeText(link);
            alert("Link copied to clipboard!");
          }
        };

        const openLink = () => {
          if (link) {
            window.open(link, "_blank");
          }
        };

        return link ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Tooltip title="Copy Link">
              <button
                onClick={copyToClipboard}
                className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <Icon icon="material-symbols:content-copy-outline" width={18} />
              </button>
            </Tooltip>
            <Tooltip title="Open Link">
              <button
                onClick={openLink}
                className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <Icon icon="material-symbols:open-in-new" width={18} />
              </button>
            </Tooltip>
          </div>
        ) : (
          "-"
        );
      },
    }),
    columnHelper.accessor("studentName", {
      header: "Student Name",
    }),
    columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      // Cell: (cell) => {
      //   const date = cell.row.original?.booking_date;
      //   return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
      // },
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),

    columnHelper.accessor("start_time", {
      header: "Start Time (UTC)",
      // Cell: (cell) => cell.row.original?.start_time || "-",
      Cell: (cell) => formatUtcTimeTo12Hour(cell.row.original.utcTime),
    }),

    columnHelper.accessor("end_time", {
      header: "End Time (UTC)",
      // Cell: (cell) => cell.row.original?.end_time || "-",
      Cell: (cell) => formatUtcTimeTo12HourAdd1hour(cell.row.original.utcTime),
    }),

    columnHelper.accessor("booking_date", {
        id: "booking_date_local",
      header: `Slot Date (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime, "date"),
    }),
    columnHelper.accessor("start_time", {
       id: "start_time_local",
      header: `Start time (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime, "start"),
    }),
    columnHelper.accessor("end_time", {
       id: "end_time_local",
      header: `End time(${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime, "end"),
    }),

    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 30,
    //   Cell: (cell) => {
    //     const rawDate = cell.row.original?.created_at;
    //     if (!rawDate) return "N/A";

    //     const dateObj = new Date(rawDate);
    //     const day = String(dateObj.getDate()).padStart(2, "0");
    //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    //     const year = dateObj.getFullYear();

    //     return `${day}-${month}-${year}`;
    //   },
    // }),
    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
    }),
  ];

  columns.unshift(
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowData = cell.row.original;
        const { rescheduleId, status, booking_date, start_time } = rowData;

        // Combine booking date and time for cutoff check
        const bookingDateTime = new Date(
          `${booking_date.split("T")[0]}T${start_time}`
        );
        const cutoffDateTime = new Date(
          bookingDateTime.getTime() - 24 * 60 * 60 * 1000
        );
        const now = new Date();
        const canReschedule = now < cutoffDateTime;

        return (
          <Box>
            {rescheduleId && status === 0 ? (
              <Button
                variant="outlined"
                color="success"
                size="small"
                disabled
                sx={{ textTransform: "none" }}
              >
                In-progress Approval
              </Button>
            ) : rescheduleId && status === 2 ? (
              <Typography
                variant="outlined"
                color="success"
                size="small"
                sx={{
                  color: "green",
                  borderColor: "green",
                  textTransform: "none",
                }}
              >
                Rescheduled
              </Typography>
            ) : !rescheduleId && status === 0 && canReschedule ? (
              <Tooltip title="Reschedule" arrow>
                <Button
                  onClick={() => handleReschedule(rowData)}
                  sx={{
                    color: "red",
                  }}
                >
                  <EventRepeatIcon />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Reschedule" arrow>
                <Button
                  sx={{
                    color: "red",
                  }}
                  disabled
                >
                  <EventRepeatIcon />
                </Button>
              </Tooltip>
            )}
          </Box>
        );
      },
    })
  );

  // columns.unshift(
  //   columnHelper.accessor("actions", {
  //     header: "Actions",
  //     Cell: ({ cell }) => {
  //       const rowData = cell.row.original;
  //       const rescheduleId = rowData.rescheduleId;
  //       const bookingDate = rowData.booking_date; // ISO format
  //       const bookingTime = rowData.start_time; // "HH:mm:ss"

  //       // Combine booking date and time
  //       const bookingDateTime = new Date(
  //         `${bookingDate.split("T")[0]}T${bookingTime}`
  //       );

  //       // Calculate cutoff time (24 hours before)
  //       const cutoffDateTime = new Date(
  //         bookingDateTime.getTime() - 24 * 60 * 60 * 1000
  //       );

  //       const now = new Date();

  //       const canReschedule = now < cutoffDateTime;

  //       return (
  //         <Box>
  //           {rescheduleId ? (
  //             <Button
  //               variant="outlined"
  //               color="success"
  //               size="small"
  //               disabled
  //               sx={{ textTransform: "none" }}
  //             >
  //               In-progress Approval
  //             </Button>
  //           ) : canReschedule ? (
  //             <Tooltip title="Reschedule" arrow>
  //               <Button
  //                 onClick={() => handleReschedule(rowData)}
  //                 sx={{
  //                   color: "red",
  //                 }}
  //               >
  //                 <EventRepeatIcon />
  //               </Button>
  //             </Tooltip>
  //           ) : (
  //             null && (
  //               <Tooltip title="Reschedule" arrow>
  //                 <Button variant="outlined" color="success" size="small">
  //                   Rescheduled
  //                 </Button>
  //               </Tooltip>
  //             )
  //           )}
  //         </Box>
  //       );
  //     },
  //   })
  // );

  return <CustomTable columns={columns} data={bookings} loading={loading} />;
};

export default ScheduleBookings;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { createMRTColumnHelper } from "material-react-table";
// import Chip from "@mui/material/Chip";
// import CustomTable from "../../../../components/custom_table/CustomTable";
// import { baseUrl } from "../../../../helper/urls";
// import { Icon } from "@iconify/react";
// import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
// import EventRepeatIcon from "@mui/icons-material/EventRepeat";
// import { useSelector } from "react-redux";

// const ScheduleBookings = () => {
//   const { token } = useSelector((state) => state.auth);
//   const [bookings, setBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchBookings = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/bookings/getBookingUpComingCounselor`,
//         { headers }
//       );
//       setBookings(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       setError("Failed to fetch bookings");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBookings();
//   }, []);

//   const handleReschedule = (rowData) => {
//     Swal.fire({
//       html: `<h4 style="font-size:14px; margin-bottom: 10px; padding:20px;">Reschedule Booking</h4>
//          <p>Please provide a reason for rescheduling:</p>`,
//       input: "text",
//       inputPlaceholder: "Enter reason here...",
//       inputAttributes: {
//         name: "reason",
//       },
//       showCancelButton: true,
//       confirmButtonText: "Yes, Reschedule",
//       cancelButtonText: "Cancel",
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       preConfirm: (reason) => {
//         if (!reason) {
//           Swal.showValidationMessage("Reason is required.");
//         }
//         return reason;
//       },
//     }).then((result) => {
//       if (result.isConfirmed) {
//         const payload = {
//           slotId: rowData.slotId, // slot ID for the new time
//           studentId: rowData.studentId, // student ID
//           bookedId: rowData.id, // existing booking ID
//           reason: result.value, // reason input from modal
//         };

//         axios
//           .post(`${baseUrl}/api/reschedule/counselor/create`, payload, {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`, // assumes token is stored in session
//             },
//           })
//           .then((res) => {
//             Swal.fire(
//               "Rescheduled!",
//               "The reschedule request has been sent to student.",
//               "success"
//             );
//             fetchBookings(); // refresh the table/list if needed
//           })
//           .catch((error) => {
//             console.error("Reschedule error:", error);
//             const message =
//               error.response?.data?.message ||
//               error.message ||
//               "Failed to reschedule.";
//             Swal.fire("Error", message, "error");
//           });
//       }
//     });
//   };

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("meet_link", {
//       header: "Meet Link",
//       Cell: ({ row }) => {
//         const link = row.original?.meet_link;
//         const rescheduleId = row.original?.rescheduleId;

//         if (rescheduleId) return "-";
//         if (!link) return "-";

//         const copyToClipboard = () => {
//           if (link) {
//             navigator.clipboard.writeText(link);
//             alert("Link copied to clipboard!");
//           }
//         };

//         const openLink = () => {
//           if (link) {
//             window.open(link, "_blank");
//           }
//         };

//         return link ? (
//           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//             <Tooltip title="Copy Link">
//               <button
//                 onClick={copyToClipboard}
//                 className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
//                 style={{ cursor: "pointer" }}
//               >
//                 <Icon icon="material-symbols:content-copy-outline" width={18} />
//               </button>
//             </Tooltip>
//             <Tooltip title="Open Link">
//               <button
//                 onClick={openLink}
//                 className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
//                 style={{ cursor: "pointer" }}
//               >
//                 <Icon icon="material-symbols:open-in-new" width={18} />
//               </button>
//             </Tooltip>
//           </div>
//         ) : (
//           "-"
//         );
//       },
//     }),
//     columnHelper.accessor("firstName", {
//       header: "Student Name",
//       Cell: (cell) =>
//         `${cell.row.original.firstName || ""} ${
//           cell.row.original.lastName || ""
//         }`,
//     }),
//     columnHelper.accessor("booking_date", {
//       header: "Slot Date",
//       Cell: (cell) => {
//         const date = cell.row.original?.booking_date;
//         return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
//       },
//     }),

//     columnHelper.accessor("start_time", {
//       header: "Start Time",
//       Cell: (cell) => cell.row.original?.start_time || "-",
//     }),

//     columnHelper.accessor("end_time", {
//       header: "End Time",
//       Cell: (cell) => cell.row.original?.end_time || "-",
//     }),

//     // columnHelper.accessor("created_at", {
//     //   header: "Created At",
//     //   size: 30,
//     //   Cell: (cell) => {
//     //     const rawDate = cell.row.original?.created_at;
//     //     if (!rawDate) return "N/A";

//     //     const dateObj = new Date(rawDate);
//     //     const day = String(dateObj.getDate()).padStart(2, "0");
//     //     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     //     const year = dateObj.getFullYear();

//     //     return `${day}-${month}-${year}`;
//     //   },
//     // }),
//     columnHelper.accessor("reqId", {
//       header: "Request ID",
//       Cell: (cell) => "DDR000" + cell.row.original?.reqId || "-",
//     }),
//   ];

//   columns.unshift(
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ cell }) => {
//         const rowData = cell.row.original;
//         const { rescheduleId, status, booking_date, start_time } = rowData;

//         // Combine booking date and time for cutoff check
//         const bookingDateTime = new Date(
//           `${booking_date.split("T")[0]}T${start_time}`
//         );
//         const cutoffDateTime = new Date(
//           bookingDateTime.getTime() - 24 * 60 * 60 * 1000
//         );
//         const now = new Date();
//         const canReschedule = now < cutoffDateTime;

//         return (
//           <Box>
//             {rescheduleId && status === 0 ? (
//               <Button
//                 variant="outlined"
//                 color="success"
//                 size="small"
//                 disabled
//                 sx={{ textTransform: "none" }}
//               >
//                 In-progress Approval
//               </Button>
//             ) : rescheduleId && status === 2 ? (
//               <Typography
//                 variant="outlined"
//                 color="success"
//                 size="small"
//                 sx={{
//                   color: "green",
//                   borderColor: "green",
//                   textTransform: "none",
//                 }}
//               >
//                 Rescheduled
//               </Typography>
//             ) : !rescheduleId && status === 0 && canReschedule ? (
//               <Tooltip title="Reschedule" arrow>
//                 <Button
//                   onClick={() => handleReschedule(rowData)}
//                   sx={{
//                     color: "red",
//                   }}
//                 >
//                   <EventRepeatIcon />
//                 </Button>
//               </Tooltip>
//             ) : null}
//           </Box>
//         );
//       },
//     })
//   );

//   // columns.unshift(
//   //   columnHelper.accessor("actions", {
//   //     header: "Actions",
//   //     Cell: ({ cell }) => {
//   //       const rowData = cell.row.original;
//   //       const rescheduleId = rowData.rescheduleId;
//   //       const bookingDate = rowData.booking_date; // ISO format
//   //       const bookingTime = rowData.start_time; // "HH:mm:ss"

//   //       // Combine booking date and time
//   //       const bookingDateTime = new Date(
//   //         `${bookingDate.split("T")[0]}T${bookingTime}`
//   //       );

//   //       // Calculate cutoff time (24 hours before)
//   //       const cutoffDateTime = new Date(
//   //         bookingDateTime.getTime() - 24 * 60 * 60 * 1000
//   //       );

//   //       const now = new Date();

//   //       const canReschedule = now < cutoffDateTime;

//   //       return (
//   //         <Box>
//   //           {rescheduleId ? (
//   //             <Button
//   //               variant="outlined"
//   //               color="success"
//   //               size="small"
//   //               disabled
//   //               sx={{ textTransform: "none" }}
//   //             >
//   //               In-progress Approval
//   //             </Button>
//   //           ) : canReschedule ? (
//   //             <Tooltip title="Reschedule" arrow>
//   //               <Button
//   //                 onClick={() => handleReschedule(rowData)}
//   //                 sx={{
//   //                   color: "red",
//   //                 }}
//   //               >
//   //                 <EventRepeatIcon />
//   //               </Button>
//   //             </Tooltip>
//   //           ) : (
//   //             null && (
//   //               <Tooltip title="Reschedule" arrow>
//   //                 <Button variant="outlined" color="success" size="small">
//   //                   Rescheduled
//   //                 </Button>
//   //               </Tooltip>
//   //             )
//   //           )}
//   //         </Box>
//   //       );
//   //     },
//   //   })
//   // );

//   return <CustomTable columns={columns} data={bookings} loading={loading} />;
// };

// export default ScheduleBookings;

// // import React, { useState, useEffect } from "react";
// // import axios from "axios";
// // import Swal from "sweetalert2";
// // import { createMRTColumnHelper } from "material-react-table";
// // import Chip from "@mui/material/Chip";
// // import CustomTable from "../../../../components/custom_table/CustomTable";
// // import { baseUrl } from "../../../../helper/urls";
// // import { Icon } from "@iconify/react";
// // import { Box, Button, IconButton, Tooltip } from "@mui/material";
// // import EventRepeatIcon from "@mui/icons-material/EventRepeat";

// // const ScheduleBookings = () => {
// //   const { token } = useSelector((state) => state.auth);
// //   const [bookings, setBookings] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   const fetchBookings = async () => {
// //     const headers = {
// //       "Content-Type": "application/json",
// //       Authorization: `Bearer ${token}`,
// //     };

// //     try {
// //       const response = await axios.get(
// //         `${baseUrl}/bookings/getBookingUpComingCounselor`,
// //         { headers }
// //       );
// //       setBookings(response.data.data);
// //       setLoading(false);
// //     } catch (error) {
// //       console.error("Error fetching bookings:", error);
// //       setError("Failed to fetch bookings");
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchBookings();
// //   }, []);

// //   const handleReschedule = (rowData) => {
// //     Swal.fire({
// //       // title: "Reschedule Booking",
// //       // text: "Please provide a reason for rescheduling:",
// //       html: `<h4 style="font-size:14px; margin-bottom: 10px; padding:20px;">Reschedule Booking</h4>
// //          <p>Please provide a reason for rescheduling:</p>`,
// //       input: "text",
// //       inputPlaceholder: "Enter reason here...",
// //       inputAttributes: {
// //         name: "reason",
// //       },
// //       showCancelButton: true,
// //       confirmButtonText: "Yes, Reschedule",
// //       cancelButtonText: "Cancel",
// //       confirmButtonColor: "#3085d6",
// //       cancelButtonColor: "#d33",
// //       preConfirm: (reason) => {
// //         if (!reason) {
// //           Swal.showValidationMessage("Reason is required.");
// //         }
// //         return reason;
// //       },
// //     }).then((result) => {
// //       if (result.isConfirmed) {
// //         const payload = {
// //           slotId: rowData.slotId, // slot ID for the new time
// //           studentId: rowData.studentId, // student ID
// //           bookedId: rowData.id, // existing booking ID
// //           reason: result.value, // reason input from modal
// //         };

// //         axios
// //           .post(`${baseUrl}/api/reschedule/counselor/create`, payload, {
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`, // assumes token is stored in session
// //             },
// //           })
// //           .then((res) => {
// //             Swal.fire(
// //               "Rescheduled!",
// //               "The reschedule request has been sent to student.",
// //               "success"
// //             );
// //             fetchBookings(); // refresh the table/list if needed
// //           })
// //           .catch((error) => {
// //             console.error("Reschedule error:", error);
// //             const message =
// //               error.response?.data?.message ||
// //               error.message ||
// //               "Failed to reschedule.";
// //             Swal.fire("Error", message, "error");
// //           });
// //       }
// //     });
// //   };

// //   // const handleReschedule = (rowData) => {
// //   //   Swal.fire({
// //   //     html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
// //   //     text: "Do you want to reschedule this booking?",
// //   //     icon: "question",
// //   //     showCancelButton: true,
// //   //     confirmButtonText: "Yes, Reschedule",
// //   //     cancelButtonText: "Cancel",
// //   //     confirmButtonColor: "#3085d6",
// //   //     cancelButtonColor: "#d33",
// //   //   }).then((result) => {
// //   //     if (result.isConfirmed) {
// //   //       const payload = {
// //   //         slotId: rowData.slotId, // slot ID for the new time
// //   //         studentId: rowData.studentId, // student ID
// //   //         bookedId: rowData.id, // existing booking ID
// //   //       };

// //   //       axios
// //   //         .post(`${baseUrl}/api/reschedule/counselor/create`, payload, {
// //   //           headers: {
// //   //             "Content-Type": "application/json",
// //   //             Authorization: `Bearer ${token}`, // assumes token is stored in session
// //   //           },
// //   //         })
// //   //         .then((res) => {
// //   //           Swal.fire(
// //   //             "Rescheduled!",
// //   //             "The booking has been successfully rescheduled.",
// //   //             "success"
// //   //           );
// //   //           fetchBookings(); // refresh the table/list if needed
// //   //         })
// //   //         .catch((error) => {
// //   //           console.error("Reschedule error:", error);
// //   //           const message =
// //   //             error.response?.data?.message ||
// //   //             error.message ||
// //   //             "Failed to reschedule.";
// //   //           Swal.fire("Error", message, "error");
// //   //         });
// //   //     }
// //   //   });
// //   // };

// //   const columnHelper = createMRTColumnHelper();
// //   const columns = [
// //     columnHelper.accessor("meet_link", {
// //       header: "Meet Link",
// //       Cell: ({ row }) => {
// //         const link = row.original?.meet_link;
// //          const rescheduleId = row.original?.rescheduleId;

// //         if (rescheduleId) return "-";
// //         if (!link) return "-";

// //         const copyToClipboard = () => {
// //           if (link) {
// //             navigator.clipboard.writeText(link);
// //             alert("Link copied to clipboard!");
// //           }
// //         };

// //         const openLink = () => {
// //           if (link) {
// //             window.open(link, "_blank");
// //           }
// //         };

// //         return link ? (
// //           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
// //             {/* <span
// //               style={{
// //                 maxWidth: "120px",
// //                 overflow: "hidden",
// //                 textOverflow: "ellipsis",
// //                 whiteSpace: "nowrap",
// //               }}
// //               title={link}
// //             >
// //               {link}
// //             </span> */}
// //             <Tooltip title="Copy Link">
// //               <button
// //                 onClick={copyToClipboard}
// //                 className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
// //                 style={{ cursor: "pointer" }}
// //               >
// //                 <Icon icon="material-symbols:content-copy-outline" width={18} />
// //               </button>
// //             </Tooltip>
// //             <Tooltip title="Open Link">
// //               <button
// //                 onClick={openLink}
// //                 className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
// //                 style={{ cursor: "pointer" }}
// //               >
// //                 <Icon icon="material-symbols:open-in-new" width={18} />
// //               </button>
// //             </Tooltip>
// //           </div>
// //         ) : (
// //           "-"
// //         );
// //       },
// //     }),
// //     columnHelper.accessor("firstName", {
// //       header: "Student Name",
// //       Cell: (cell) =>
// //         `${cell.row.original.firstName || ""} ${
// //           cell.row.original.lastName || ""
// //         }`,
// //     }),
// //     columnHelper.accessor("booking_date", {
// //       header: "Slot Date",
// //       Cell: (cell) => {
// //         const date = cell.row.original?.booking_date;
// //         return date ? new Date(date).toLocaleDateString("en-IN") : "N/A";
// //       },
// //     }),

// //     columnHelper.accessor("start_time", {
// //       header: "Start Time",
// //       Cell: (cell) => cell.row.original?.start_time || "-",
// //     }),

// //     columnHelper.accessor("end_time", {
// //       header: "End Time",
// //       Cell: (cell) => cell.row.original?.end_time || "-",
// //     }),

// //     columnHelper.accessor("created_at", {
// //       header: "Created At",
// //       size: 30,
// //       Cell: (cell) => {
// //         const rawDate = cell.row.original?.created_at;
// //         if (!rawDate) return "N/A";

// //         const dateObj = new Date(rawDate);
// //         const day = String(dateObj.getDate()).padStart(2, "0");
// //         const month = String(dateObj.getMonth() + 1).padStart(2, "0");
// //         const year = dateObj.getFullYear();

// //         return `${day}-${month}-${year}`;
// //       },
// //     }),
// //     columnHelper.accessor("reqId", {
// //       header: "Request ID",
// //       Cell: (cell) => "DDR000" + cell.row.original?.reqId || "-",
// //     }),
// //   ];

// //   columns.unshift(
// //     columnHelper.accessor("actions", {
// //       header: "Actions",
// //       Cell: ({ cell }) => {
// //         const rowData = cell.row.original;
// //         const rescheduleId = rowData.rescheduleId;
// //         const bookingDate = rowData.booking_date; // ISO format
// //         const bookingTime = rowData.start_time; // "HH:mm:ss"

// //         // Combine booking date and time
// //         const bookingDateTime = new Date(
// //           `${bookingDate.split("T")[0]}T${bookingTime}`
// //         );

// //         // Calculate cutoff time (24 hours before)
// //         const cutoffDateTime = new Date(
// //           bookingDateTime.getTime() - 24 * 60 * 60 * 1000
// //         );

// //         const now = new Date();

// //         const canReschedule = now < cutoffDateTime;

// //         return (
// //           <Box>
// //             {rescheduleId ? (
// //               <Button
// //                 variant="outlined"
// //                 color="success"
// //                 size="small"
// //                 disabled
// //                 sx={{ textTransform: "none" }}
// //               >
// //                 Already Rescheduled
// //               </Button>
// //             ) : canReschedule ? (
// //               <Tooltip title="Reschedule" arrow>
// //                 <IconButton
// //                   onClick={() => handleReschedule(rowData)}
// //                   sx={{ color: "red" }}
// //                 >
// //                   <EventRepeatIcon />
// //                 </IconButton>
// //               </Tooltip>
// //             ) : null}
// //           </Box>
// //         );
// //       },
// //     })
// //   );

// //   return <CustomTable columns={columns} data={bookings} loading={loading} />;
// // };

// // export default ScheduleBookings;
